import purchase1 from "./purchase1"
import purchase2 from "./purchase2"
import purchase_order1 from "./purchase_order1"
import purchase_order2 from "./purchase_order2"
import purchase_return1 from "./purchase_return1"
import purchase_return2 from "./purchase_return2"
import sale1 from "./sale1"
import sale2 from "./sale2"
import sale_order1 from "./sale_order1"
import sale_order2 from "./sale_order2"
import sale_return1 from "./sale_return1"
import sale_return2 from "./sale_return2"
import assembly1 from "./assembly1"
import assembly2 from "./assembly2"
// label
// - 调拨单 dispatch
// - 盘点单 inventory
// - 其他入库 other_in
// - 其他出库 other_out
// - 入库单 stock_in
// - 出库单stock_out
import label1 from "./label1"
import label2 from "./label2"
import dispatch1 from "./dispatch1"
import dispatch2 from "./dispatch2"
import inventory1 from "./inventory1"
import inventory2 from "./inventory2"
import other_in1 from "./other_in1"
import other_in2 from "./other_in2"
import other_out1 from "./other_out1"
import other_out2 from "./other_out2"
import stock_in1 from "./stock_in1"
import stock_in2 from "./stock_in2"
import stock_out1 from "./stock_out1"
import stock_out2 from "./stock_out2"


// fin_account_trans 财户转账
import fin_account_trans from "./fin_account_trans"
// fin_comego_in收款单
import fin_comego_in from "./fin_comego_in"
// fin_comego_out 付款单
import fin_comego_out from "./fin_comego_out"
// 日常收入 fin_dayily_in
import fin_dayily_in from "./fin_dayily_in"
// 日常支出 fin_dayily_out
import fin_dayily_out from "./fin_dayily_out"
// 核销单 fin_account_trans
import fin_write_off from "./fin_write_off"
export default {
    ["/hiPrint/getHiPrintResourceByCatId/purchase"]: [purchase1, purchase2],
    ["/hiPrint/getHiPrintResourceByCatId/purchase_order"]: [purchase_order1, purchase_order2],
    ["/hiPrint/getHiPrintResourceByCatId/purchase_return"]: [purchase_return1, purchase_return2],
    ["/hiPrint/getHiPrintResourceByCatId/sale"]: [sale1, sale2],
    ["/hiPrint/getHiPrintResourceByCatId/sale_order"]: [sale_order1, sale_order2],
    ["/hiPrint/getHiPrintResourceByCatId/sale_return"]: [sale_return1, sale_return2],
    ["/hiPrint/getHiPrintResourceByCatId/assembly"]: [assembly1, assembly2],
    ["/hiPrint/getHiPrintResourceByCatId/label"]: [label1, label2],
    ["/hiPrint/getHiPrintResourceByCatId/dispatch"]: [dispatch1, dispatch2],
    ["/hiPrint/getHiPrintResourceByCatId/inventory"]: [inventory1, inventory2],
    ["/hiPrint/getHiPrintResourceByCatId/other_in"]: [other_in1, other_in2],
    ["/hiPrint/getHiPrintResourceByCatId/other_out"]: [other_out1, other_out2],
    ["/hiPrint/getHiPrintResourceByCatId/stock_in"]: [stock_in1, stock_in2],
    ["/hiPrint/getHiPrintResourceByCatId/stock_out"]: [stock_out1, stock_out2],
    ["/hiPrint/getHiPrintResourceByCatId/fin_account_trans"]:[fin_account_trans],
    ["/hiPrint/getHiPrintResourceByCatId/fin_comego_in"]:[fin_comego_in],
    ["/hiPrint/getHiPrintResourceByCatId/fin_comego_out"]:[fin_comego_out],
    ["/hiPrint/getHiPrintResourceByCatId/fin_dayily_in"]:[fin_dayily_in],
    ["/hiPrint/getHiPrintResourceByCatId/fin_dayily_out"]:[fin_dayily_out],
    ["/hiPrint/getHiPrintResourceByCatId/fin_write_off"]:[fin_write_off]
}